import React, { useState } from 'react';
import Select from 'react-select';
import { ManText } from "@craft-design-system/core-components-react";
import Yearly_mileage_filter from './Yearly_mileage_filter';
import filters from '../assets/images/filters.svg';
import '../App.css';
import DateRangePicker from './DateRangePicker';

// Add a style tag for the loading animation
const loadingAnimationStyle = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const FilterSidebar = ({
  dropdownData,
  selectedValues,
  handleSelectChange,
  customStyles,
  onvaluesChange,
  startDate,
  endDate,
  onDateChange,
  isDynamicFiltering,
  onResetFilters,
  onApplyDynamicFiltering,
  isLoading
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Utility function to format date to YYYY-MM-DD
  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toISOString().split('T')[0];
  };

  const renderDropdown = (columnName, values) => {
    // If values is undefined or empty, show empty dropdown but don't crash
    const safeValues = Array.isArray(values) && values.length > 0 ? values : [];
    const options = safeValues.map(value => ({ label: value, value }));
    
    // Safely handle selectedValues in case it's null
    if (!selectedValues) {
      console.warn("selectedValues is null in renderDropdown");
    }
    
    // Handle special case for Segment filter which might have different casing in selectedValues
    let selectedValueKey = columnName;
    if (selectedValues && columnName === "Segment") {
      // Safely check the existence of properties
      const hasUppercase = !!selectedValues.Segment;
      const hasLowercase = !!selectedValues.segment;
      
      if (!hasUppercase && hasLowercase) {
        selectedValueKey = "segment";
      }
    }
    
    return (
      <div className="sidebar-filters" key={columnName} style={{ maxWidth: '240px' }}>
        <ManText className="filter-text" variant={"heading-s"} as={"span"}>
          {columnName}
        </ManText>
        <Select
          isMulti
          name={columnName}
          options={options}
          value={(selectedValues && selectedValues[selectedValueKey]) 
                 ? selectedValues[selectedValueKey].map(val => ({ label: val, value: val })) 
                 : []}
          styles={customStyles}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={(event) => handleSelectChange(event, columnName)}
          noOptionsMessage={() => "No options available"}
        />
      </div>
    );
  };

  return (
    <div className='sidebar1' style={{ marginTop: '10px', padding: '6px' }}>
      <style>{loadingAnimationStyle}</style>
      
      {/* {isDynamicFiltering && (
        <div style={{ 
          backgroundColor: '#e6f7ff', 
          padding: '8px', 
          borderRadius: '4px', 
          marginBottom: '10px',
          border: '1px solid #91d5ff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <ManText variant={"body-s"} as={"span"} style={{ color: '#0050b3' }}>
            Dynamic filtering applied
          </ManText>
        </div>
      )} */}
      <div className="dropdown-section" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

        {/* Date Range Section */}


        {/* Dropdowns */}
        {dropdownData && Object.entries(dropdownData).length > 0 ? (
          <>
            {Object.entries(dropdownData).slice(0, 7).map(([key, values]) => {
              // Special handling for segment vs Segment to avoid duplicate filters
              if (key === "segment" && "Segment" in dropdownData) {
                console.log("Skipping lowercase 'segment' in favor of 'Segment'");
                return null;
              }
              return renderDropdown(key, values);
            })}
            {isOpen && Object.entries(dropdownData).slice(7).map(([key, values]) => {
              // Same special handling for the remaining filters
              if (key === "segment" && "Segment" in dropdownData) {
                return null;
              }
              return renderDropdown(key, values);
            })}
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <ManText variant={"body-m"} as={"p"} style={{ color: '#5B6F85' }}>
              No filter options available. Please reset filters.
            </ManText>
          </div>
        )}

        {/* Yearly Mileage Filter */}
        {isOpen && <Yearly_mileage_filter onValuesChange={onvaluesChange} />}

        {/* Toggle Button */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '10px' }}>
          <button className='filters_button' onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? 'Less filters' : 'More filters'}
            <img src={filters} alt="button image" className='filter_image' />
          </button>
          
          
        </div>

        {/* <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onDateChange={onDateChange}
          formatDate={formatDate}
        /> */}

      </div>
    </div>
  );
};

export default FilterSidebar;
